"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneType = void 0;
/**
 * Identifier for the type of user phone
 *
 * @public
 * @memberof IUserPhone
 */
var PhoneType;
(function (PhoneType) {
    PhoneType["Mobile"] = "m";
    PhoneType["Home"] = "h";
})(PhoneType = exports.PhoneType || (exports.PhoneType = {}));
//# sourceMappingURL=UserPhone.js.map